import { IRouteMenuConfig } from 'models/global';
import i18next from 'i18next';
import zhCN from 'antd/lib/locale/zh_CN';
import enUS from 'antd/lib/locale/en_US';
import ruRU from 'antd/lib/locale/ru_RU';
import { customLocalStorage } from 'utils/storage';
import { getCurrentLang } from '../utils/i18n-lang';

declare global {
  interface Window {
    gapi: any;
    DSP_USER_ID: string;
    DSP_USER_COUNTRY: string;
  }
}

export enum LoginStatus {
  NOLOGIN = 'nologin',
  PENDING = 'pending',
  LOGINED = 'logined',
}

export const LANG_CONFIG = {
  zh: {
    name: '中文',
    locale: zhCN,
    moment: 'zh-cn',
  },
  en: {
    name: 'English',
    locale: enUS,
    moment: 'en-gb',
  },
  ru: {
    name: 'Русский', // 俄语
    locale: ruRU,
    moment: 'ru',
  },
};

// @ts-ignore
export const ROOT = process.env.WEB_SERVICE_ROOT || window.WEB_SERVICE_ROOT;
// @ts-ignore
export const LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL || window.LOGOUT_URL;
export const PRODUCT_NAME = 'DSP';
/** 当前域名与商务中心域名对应的map */
export const CRM_URL_MAP = {
  'ads.bigo.sg': 'business.bigo.sg',
  'dsp.bigovideo.ru': 'business.bigovideo.ru',
  'ad.adsbigo.com': 'business.adsbigo.com',
  'ads-cdn.azureedge.net': 'business-cdn.azureedge.net',
  'ads.azureedge.net': 'business-back.azureedge.net',
  'ads-backup.azureedge.net': 'business-backup.azureedge.net',
  'bgads.basketballgame.fun': 'bgbusiness.basketballgame.fun',
  'ads.pubefjjs.site': 'business.pubefjjs.site',
  'dsp.pubefjjs.site': 'business.pubefjjs.site',
};

/** 是否为测试环境 */
export const isTest = window.location.hostname.includes('gray') || window.location.hostname.includes('test');

/** 官网链接配置 */
export const ADS_URL_CONFIG = {
  HOST: isTest ? 'http://test.adsbigo.com' : 'https://www.adsbigo.com',
  HELP_PATH: isTest ? '/helpCenter.html' : '/help',
};

export const DSP_ADVERT_CREATE = 'DSP-advert-create';
export const LOCALSTORAGE_LANGUAGE = 'BIGO_ADS_LANGUAGE';
/** pear字典值配置本地存储key */
export const DSP_PEAR_DICT_CONFIG = 'DSP_PEAR_DICT_CONFIG';

// 有登录状态时读取用户的语言配置，否则优先读取缓存，再读取浏览器语言
// 当前系统所选语言
// eslint-disable-next-line import/no-mutable-exports
export let CURRENT_LANGUAGE = getCurrentLang();

// 当前系统所选语言配置
// eslint-disable-next-line import/no-mutable-exports
export let CURRENT_LOCALE = LANG_CONFIG[CURRENT_LANGUAGE] ? LANG_CONFIG[CURRENT_LANGUAGE] : LANG_CONFIG.en;

export function setLanguage(lang) {
  customLocalStorage.setItem(LOCALSTORAGE_LANGUAGE, lang);
  CURRENT_LANGUAGE = lang; // 当前系统所选语言
  CURRENT_LOCALE = LANG_CONFIG[CURRENT_LANGUAGE] ? LANG_CONFIG[CURRENT_LANGUAGE] : LANG_CONFIG.en; // 当前系统所选语言配置
}

export enum ResponseCode {
  SUCCESS = 0,
}

// 需要过滤的敏感请求
export const SENSITIVE_URL = ['/api/dsp/base/login'];

export enum Resource {
  AdvertRead = 20, // 投放管理下所有读取操作
  AdvertEdit = 21, // 投放管理下所有增删改操作
  ReportRead = 30, // 数据报表下所有读取操作
  ReportEdit = 31, // 数据报表下所有增删改操作
  AppRead = 40, // 应该管理下所有读取操作
  AppEdit = 41, // 应用管理下所有增删改操作
  Pixel = -1, // pixel模块下所有读写操作
  Material = -2, // 素材库模块入口白名单
  Target = -3, // 受众管理模块入口白名单
  Goods = -4, // 商品目录模块入口白名单
  Form = -5, // 线索表单模块入口白名单
  Tools = -6, // 工具模块入口白名单

  MaterialEdit = 70, // 素材库下所有增删改操作
  MaterialRead = 71, // 素材库下所有读取操作
  TargetEdit = 80, // 受众管理下所有增删改操作
  TargetRead = 81, // 受众管理下所有读取操作
  PixelEdit = 90, // Pixel下所有增删改操作
  PixelRead = 91, // Pixel下所有读取操作
  AccountEdit = 101, // 账户信息下所有增删改操作
  AccountRead = 100, // 账户信息下所有读取操作
  WebPageRead = 110, // 网页事件下所有读取操作 这两个权限点受 conversion_no_pixel 白名单控制，src/sagas/root.ts
  WebPageEdit = 111, // 网页事件下所有增删改操作 这两个权限点受 conversion_no_pixel 白名单控制，src/sagas/root.ts
  GoodsRead = 112, // 商品目录下所有读取操作
  GoodsEdit = 113, // 商品目录下所有增删改操作
  FormRead = 114, // 线索表单所有读取操作
  FormEdit = 115, // 线索表单所有增删改操作
}

export function getMenuConfig() {
  const menuConfig: IRouteMenuConfig[] = [
    {
      path: '/',
      title: i18next.t('lang001'),
    },
    {
      path: '/advert',
      title: i18next.t('lang002'),
    },
    {
      path: '/report/home',
      title: i18next.t('lang210'),
    },
    {
      path: '/resource',
      title: i18next.t('lang004'),
      children: [
        { path: '/resource/app', title: i18next.t('lang005') },
        { path: '/resource/webpage', title: i18next.t('lang1126') },
        { path: '/resource/pixel', title: i18next.t('lang723') },
        { path: '/resource/material', title: i18next.t('lang659') },
        { path: '/resource/target', title: i18next.t('lang690') },
        { path: '/resource/goods', title: i18next.t('lang1759') },
        { path: '/resource/form', title: i18next.t('lang1871') },
      ],
    },
    {
      path: '/tools',
      title: i18next.t('lang1966'),
      children: [
        { path: '/tools/playableTransfer', title: i18next.t('lang1967'), externalPath: PLAYABLE_TRANSFER_PLATFORM_URL },
      ],
    },
  ];
  return menuConfig;
}

export const TIMEZONE = [
  { label: '(UTC +12:00) Pacific/Auckland', value: 12 },
  { label: '(UTC +12:00) Pacific/Majuro', value: 12 },
  { label: '(UTC +11:00) Asia/Magadan', value: 11 },
  { label: '(UTC +11:00) Asia/Kamchatka', value: 11 },
  { label: '(UTC +10:00) Australia/Sydney', value: 10 },
  { label: '(UTC +10:00) Asia/Vladivostok', value: 10 },
  { label: '(UTC +09:30) Australia/Broken_Hill', value: 9.5 },
  { label: '(UTC +09:00) Asia/Jayapura', value: 9 },
  { label: '(UTC +09:00) Asia/Tokyo', value: 9 },
  { label: '(UTC +09:00) Asia/Seoul', value: 9 },
  { label: '(UTC +09:00) Asia/Yakutsk', value: 9 },
  { label: '(UTC +08:00) Australia/Perth', value: 8 },
  { label: '(UTC +08:00) Asia/Beijing', value: 8 },
  { label: '(UTC +08:00) Asia/Hong_Kong', value: 8 },
  { label: '(UTC +08:00) Asia/Makassar', value: 8 },
  { label: '(UTC +08:00) Asia/Kuala_Lumpur', value: 8 },
  { label: '(UTC +08:00) Asia/Manila', value: 8 },
  { label: '(UTC +08:00) Asia/Irkutsk', value: 8 },
  { label: '(UTC +08:00) Asia/Singapore', value: 8 },
  { label: '(UTC +08:00) Asia/Taipei', value: 8 },
  { label: '(UTC +07:00) Asia/Jakarta', value: 7 },
  { label: '(UTC +07:00) Asia/Krasnoyarsk', value: 7 },
  { label: '(UTC +07:00) Asia/Bangkok', value: 7 },
  { label: '(UTC +07:00) Asia/Ho_Chi_Minh', value: 7 },
  { label: '(UTC +06:00) Asia/Dhaka', value: 6 },
  { label: '(UTC +06:00) Asia/Omsk', value: 6 },
  { label: '(UTC +05:30) Asia/Kolkata', value: 5.5 },
  { label: '(UTC +05:30) Asia/Colombo', value: 5.5 },
  { label: '(UTC +05:00) Indian/Maldives', value: 5 },
  { label: '(UTC +05:00) Asia/Karachi', value: 5 },
  { label: '(UTC +05:00) Asia/Yekaterinburg', value: 5 },
  { label: '(UTC +04:00) Asia/Dubai', value: 4 },
  { label: '(UTC +04:00) Indian/Mauritius', value: 4 },
  { label: '(UTC +04:00) Asia/Muscat', value: 4 },
  { label: '(UTC +03:00) Asia/Bahrain', value: 3 },
  { label: '(UTC +03:00) Asia/Baghdad', value: 3 },
  { label: '(UTC +03:00) Africa/Nairobi', value: 3 },
  { label: '(UTC +03:00) Asia/Kuwait', value: 3 },
  { label: '(UTC +03:00) Asia/Qatar', value: 3 },
  { label: '(UTC +03:00) Europe/Moscow', value: 3 },
  { label: '(UTC +03:00) Europe/Samara', value: 3 },
  { label: '(UTC +03:00) Asia/Riyadh', value: 3 },
  { label: '(UTC +02:00) Europe/Sofia', value: 2 },
  { label: '(UTC +02:00) Asia/Nicosia', value: 2 },
  { label: '(UTC +02:00) Europe/Tallinn', value: 2 },
  { label: '(UTC +02:00) Africa/Cairo', value: 2 },
  { label: '(UTC +02:00) Europe/Helsinki', value: 2 },
  { label: '(UTC +02:00) Europe/Athens', value: 2 },
  { label: '(UTC +02:00) Asia/Jerusalem', value: 2 },
  { label: '(UTC +02:00) Asia/Amman', value: 2 },
  { label: '(UTC +02:00) Asia/Beirut', value: 2 },
  { label: '(UTC +02:00) Europe/Vilnius', value: 2 },
  { label: '(UTC +02:00) Europe/Riga', value: 2 },
  { label: '(UTC +02:00) Asia/Gaza', value: 2 },
  { label: '(UTC +02:00) Europe/Bucharest', value: 2 },
  { label: '(UTC +02:00) Europe/Kaliningrad', value: 2 },
  { label: '(UTC +02:00) Europe/Istanbul', value: 2 },
  { label: '(UTC +02:00) Europe/Kiev', value: 2 },
  { label: '(UTC +02:00) Africa/Johannesburg', value: 2 },
  { label: '(UTC +01:00) Europe/Vienna', value: 1 },
  { label: '(UTC +01:00) Europe/Sarajevo', value: 1 },
  { label: '(UTC +01:00) Europe/Brussels', value: 1 },
  { label: '(UTC +01:00) Europe/Zurich', value: 1 },
  { label: '(UTC +01:00) Europe/Prague', value: 1 },
  { label: '(UTC +01:00) Europe/Berlin', value: 1 },
  { label: '(UTC +01:00) Europe/Copenhagen', value: 1 },
  { label: '(UTC +01:00) Europe/Madrid', value: 1 },
  { label: '(UTC +01:00) Europe/Paris', value: 1 },
  { label: '(UTC +01:00) Europe/Zagreb', value: 1 },
  { label: '(UTC +01:00) Europe/Budapest', value: 1 },
  { label: '(UTC +01:00) Europe/Rome', value: 1 },
  { label: '(UTC +01:00) Europe/Luxembourg', value: 1 },
  { label: '(UTC +01:00) Europe/Skopje', value: 1 },
  { label: '(UTC +01:00) Europe/Malta', value: 1 },
  { label: '(UTC +01:00) Africa/Lagos', value: 1 },
  { label: '(UTC +01:00) Europe/Amsterdam', value: 1 },
  { label: '(UTC +01:00) Europe/Oslo', value: 1 },
  { label: '(UTC +01:00) Europe/Warsaw', value: 1 },
  { label: '(UTC +01:00) Europe/Belgrade', value: 1 },
  { label: '(UTC +01:00) Europe/Stockholm', value: 1 },
  { label: '(UTC +01:00) Europe/Ljubljana', value: 1 },
  { label: '(UTC +01:00) Europe/Bratislava', value: 1 },
  { label: '(UTC +01:00) Africa/Tunis', value: 1 },
  { label: '(UTC +00:00) Atlantic/Canary', value: 0 },
  { label: '(UTC +00:00) Europe/London', value: 0 },
  { label: '(UTC +00:00) Africa/Accra', value: 0 },
  { label: '(UTC +00:00) Europe/Dublin', value: 0 },
  { label: '(UTC +00:00) Atlantic/Reykjavik', value: 0 },
  { label: '(UTC +00:00) Africa/Casablanca', value: 0 },
  { label: '(UTC +00:00) Europe/Lisbon', value: 0 },
  { label: '(UTC -01:00) Atlantic/Azores', value: -1 },
  { label: '(UTC -02:00) America/Noronha', value: -2 },
  { label: '(UTC -03:00) America/Argentina/San_Luis', value: -3 },
  { label: '(UTC -03:00) America/Argentina/Buenos_Aires', value: -3 },
  { label: '(UTC -03:00) America/Argentina/Salta', value: -3 },
  { label: '(UTC -03:00) America/Belem', value: -3 },
  { label: '(UTC -03:00) America/Sao_Paulo', value: -3 },
  { label: '(UTC -03:00) America/Montevideo', value: -3 },
  { label: '(UTC -03:30) America/St_Johns', value: -3.5 },
  { label: '(UTC -04:00) America/La_Paz', value: -4 },
  { label: '(UTC -04:00) America/Campo_Grande', value: -4 },
  { label: '(UTC -04:00) America/Blanc-Sablon', value: -4 },
  { label: '(UTC -04:00) America/Halifax', value: -4 },
  { label: '(UTC -04:00) America/Santiago', value: -4 },
  { label: '(UTC -04:00) America/Santo_Domingo', value: -4 },
  { label: '(UTC -04:00) America/Puerto_Rico', value: -4 },
  { label: '(UTC -04:00) America/Asuncion', value: -4 },
  { label: '(UTC -04:00) America/Port_of_Spain', value: -4 },
  { label: '(UTC -04:30) America/Caracas', value: -4.5 },
  { label: '(UTC -05:00) America/New_York', value: -5 },
  { label: '(UTC -05:00) America/Nassau', value: -5 },
  { label: '(UTC -05:00) America/Atikokan', value: -5 },
  { label: '(UTC -05:00) America/Iqaluit', value: -5 },
  { label: '(UTC -05:00) America/Toronto', value: -5 },
  { label: '(UTC -05:00) America/Bogota', value: -5 },
  { label: '(UTC -05:00) America/Guayaquil', value: -5 },
  { label: '(UTC -05:00) America/Jamaica', value: -5 },
  { label: '(UTC -05:00) America/Panama', value: -5 },
  { label: '(UTC -05:00) America/Lima', value: -5 },
  { label: '(UTC -06:00) America/Chicago', value: -6 },
  { label: '(UTC -06:00) America/Rainy_River', value: -6 },
  { label: '(UTC -06:00) America/Regina', value: -6 },
  { label: '(UTC -06:00) Pacific/Easter', value: -6 },
  { label: '(UTC -06:00) America/Costa_Rica', value: -6 },
  { label: '(UTC -06:00) Pacific/Galapagos', value: -6 },
  { label: '(UTC -06:00) America/Guatemala', value: -6 },
  { label: '(UTC -06:00) America/Tegucigalpa', value: -6 },
  { label: '(UTC -06:00) America/Mexico_City', value: -6 },
  { label: '(UTC -06:00) America/Managua', value: -6 },
  { label: '(UTC -06:00) America/El_Salvador', value: -6 },
  { label: '(UTC -07:00) America/Denver', value: -7 },
  { label: '(UTC -07:00) America/Phoenix', value: -7 },
  { label: '(UTC -07:00) America/Dawson_Creek', value: -7 },
  { label: '(UTC -07:00) America/Edmonton', value: -7 },
  { label: '(UTC -07:00) America/Hermosillo', value: -7 },
  { label: '(UTC -07:00) America/Mazatlan', value: -7 },
  { label: '(UTC -08:00) America/Los_Angeles', value: -8 },
  { label: '(UTC -08:00) America/Dawson', value: -8 },
  { label: '(UTC -08:00) America/Vancouver', value: -8 },
  { label: '(UTC -08:00) America/Tijuana', value: -8 },
  { label: '(UTC -09:00) America/Anchorage', value: -9 },
  { label: '(UTC -10:00) Pacific/Honolulu', value: -10 },
  { label: '(UTC -11:00) Pacific/Apia', value: -11 },
  { label: '(UTC -11:00) Pacific/Midway', value: -11 },
  { label: '(UTC -11:00) Pacific/Niue', value: -11 },
  { label: '(UTC -11:00) Pacific/Pago Pago', value: -11 },
];

// 功能白名单枚举
export enum FUND_IDS_ENUM {
  web_page_others = 'web_page_others', // 网页事件的三方监测可选others
  conversion_no_pixel = 'conversion_no_pixel', // 转化量(不设置Pixel)，网页事件菜单可见，广告组表单可选网页事件
  dsp_adAc_interest = 'dsp-adAc-interest', // 是否处于兴趣定向的白名单中，下同
  dsp_adAc_app_download = 'dsp-adAc-app-download', // apk落地页推广
  dsp_adAc_pixel = 'dsp-adAc-pixel', // 是否开放pixel相关功能
  dsp_adAc_material = 'dsp-adAc-material', // 是否开放素材库相关功能
  dsp_adAc_custom_audience = 'dsp-adAc-custom-audience', // 是否开放受众管理相关功能
  dsp_adAc_other_monitor = 'dsp-adAc-other-monitor', // 应用管理三方监测是否可选others
  dsp_adAc_deeplink = 'dsp-adAc-deeplink', // 是否开放广告组设置deeplink
  custom_audience_update = 'custom-audience-update', // 是否开放人群包更新功能
  custom_audience_share = 'custom_audience_share', // 是否开放人群包分享功能
  lookalike_audience = 'lookalike-audience', // 是否支持相似受众功能
  ad_interact_audience = 'ad-interact-audience', // 受众管理三期
  app_event_aeo = 'app_event_aeo', // 应用事件支持一阶段优化转化
  rta_lazada = 'rta_lazada', // Lazada RTA 白名单
  aid_attribute = 'aid_attribute', // 是否有启用辅助归因的权限
  pixel_xpath = 'pixel_xpath', // pixel是否可选标准模式
  pixel_install_type = 'pixel_install_type', // pixel是否可选第三方安装
  pixel_deep_goal = 'pixel_deep_goal', // pixel是否支持深度优化目标
  app_visit = 'app_visit', // 推广目的支持选择"App内访问"
  landing_page_send_pkg_name = 'landing_page_send_pkg_name', // 广告组表单支持配置下发包名
  app_interaction = 'app_interaction', // 推广目的支持选择应用互动
  app_click_track_as_land_url = 'app_click_track_as_land_url', // 设置点击监测地址为推广地址
  cancel_clicktracker = 'cancel_clicktracker', // 不检查是否设置点击监测链接
  playable_ad = 'playable_ad', // 是否允许创建试玩广告和上传试玩广告素材
  is_app_interaction_show_deep_goal = 'is_app_interaction_show_deep_goal', // 应用互动广告是否显示深层优化目标选择
  allow_scheme_url = 'allow_scheme_url', // 是否允许scheme格式的url通过校验
  app_ban = 'app-ban', // ban版位
  /** 推广地址填写白名单 */
  landing_page_edit = 'landing_page_edit',
  /** cpc 加速投放隐藏 */
  bid_speed_up = 'bid_speed_up',
  /** 应用互动deeplink非必填白名单 */
  app_interaction_no_deeplink = 'app_interaction_no_deeplink',
  /** 应用内事件 t+1回传	 */
  delay_post_back = 'delay_post_back',
  /** aeo 双出价 */
  aeo_double_bid = 'aeo_double_bid',
  /** 直投拆分双出价 */
  split_ocpc_bid = 'split_ocpc_bid',
  /** 深转 */
  ocpc_deep_conversion = 'ocpc_deep_conversion',
  /** AE RTA白名单 */
  rta_ae = 'rta_ae',
  /** 机型白名单 */
  audience_appoint_model = 'audience_appoint_model',
  /** 商品目录 */
  series_goods = 'series_goods',
  /** 俄罗斯应用商店 */
  ru_app_store = 'ru-app-store',
  /** 广告观看应用内事件白名单 */
  iaa_roas = 'iaa_roas',
  /** 旧的程序化创意 */
  procedural_creativity = 'procedural_creativity',
  /** 新的程序化创意 */
  prog_creative = 'prog_creative',
  /** 支持修改应用事件统计方式 */
  event_statistic_mode = 'event_statistic_mode',
  /** 即时表单 */
  instant_form = 'instant_form',
  /** 推广目的-品牌知名度 */
  brand_ad = 'brand_ad',
  /** 试玩转换入口 */
  playable_transform = 'playable_transform',
  /** 默认程序化创意白名单 */
  prog_creative_open_by_default = 'prog_creative_open_by_default',
  /** 优化次留 */
  optimize_d2_retension = 'optimize_d2_retension',
  /** 广告层级可编辑监测链接 */
  ad_tracking_link = 'ad_tracking_link',
}

// 裁剪后的图片文件超过该尺寸时需触发压缩
export const MAX_IMAGE_SIZE = 800 * 1024;

// 列表查询的最大条数
export const MAX_PAGE_SIZE = 100000;

// google drive上传素材的文件夹ID
export const GOOGLE_DRIVE_FOLDER_ID = '1YpO1TeDfO7D6Zr1OFV82AuGSc6irB4Ur';

/** 全局延迟通知事件类型枚举 */
export enum DelayEventTypeEnum {
  /** 广告模块-广告系列-用户修改推广目的 */
  ADVERT_SERIES_PROMOTED_ON_CHANGE,
}

/** 广告表单，需要二次弹框确认项的弹框确认类型 */
export enum AdvertConfirmTypeEnum {
  /** 广告组 - 确认是否符合建议出价 */
  GROUP_ADVICE_BID = 'GROUP_ADVICE_BID',
}

/** 获取试玩平台链接 */
function getPlayableSiteUrl() {
  if (isTest) {
    return 'http://playable-test.bigo.sg';
  }
  if (window.location.hostname.includes('.ru')) {
    return 'https://playablefun.ru';
  }
  return 'https://playable.studio';
}

/** 试玩转换平台域名 */
export const PLAYABLE_TRANSFER_PLATFORM_URL = getPlayableSiteUrl();
// 默认分隔符
export const COMMON_TOKEN_SEPARATORS = ['\r\n', '\n', ';', '；'];
